import { z } from 'zod'
import { DateOrStringSchema as dateOrString } from './common'

// ─── Admin Users ─────────────────────────────────────────

export const AdminUserSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  role: z.string(),
  tenantId: z.string().nullable(),
  createdAt: dateOrString,
  updatedAt: dateOrString,
})

export const UpdateUserRoleSchema = z.object({
  role: z.enum(['student', 'instructor', 'admin', 'superadmin']),
})

export type AdminUser = z.infer<typeof AdminUserSchema>
export type UpdateUserRoleInput = z.infer<typeof UpdateUserRoleSchema>

// ─── Admin Tenants ───────────────────────────────────────

export const AdminTenantSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  authProvider: z.string(),
  authConfig: z.record(z.any()),
  isActive: z.boolean(),
  maxUsers: z.number().nullable(),
  maxStorage: z.number().nullable(),
  settings: z.record(z.any()).nullable(),
  createdAt: dateOrString,
  updatedAt: dateOrString,
})

export const CreateTenantSchema = z.object({
  slug: z.string().min(1),
  name: z.string().min(1),
  authProvider: z.string().optional(),
  authConfig: z.record(z.any()).optional(),
  maxUsers: z.number().int().positive().optional(),
})

export const UpdateTenantSchema = z.object({
  name: z.string().min(1).optional(),
  slug: z.string().min(1).optional(),
  authProvider: z.string().optional(),
  authConfig: z.record(z.any()).optional(),
  isActive: z.boolean().optional(),
  maxUsers: z.number().int().positive().nullable().optional(),
  maxStorage: z.number().int().positive().nullable().optional(),
  settings: z.record(z.any()).optional(),
})

export type AdminTenant = z.infer<typeof AdminTenantSchema>
export type CreateTenantInput = z.infer<typeof CreateTenantSchema>
export type UpdateTenantInput = z.infer<typeof UpdateTenantSchema>

// ─── Admin Ratings ───────────────────────────────────────

export const AdminRatingSchema = z.object({
  feedback: z.object({
    id: z.string(),
    userId: z.string(),
    lessonId: z.string(),
    rating: z.number().int().min(1).max(5),
    comment: z.string().nullable(),
    createdAt: dateOrString,
    updatedAt: dateOrString,
    tenantId: z.string().nullable(),
  }),
  userName: z.string().nullable(),
  userEmail: z.string().nullable(),
  lessonTitle: z.string().nullable(),
})

export type AdminRating = z.infer<typeof AdminRatingSchema>
